var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetedPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamlinehq-shopping-business-target-money-shopping-24-ico_7OM8zYQpYfGRSW0E",
    clipPath: "url(#clip0_8676_1527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.45509 7.11062C1.45509 10.6639 4.33563 13.5445 7.88895 13.5445C11.4423 13.5445 14.3228 10.6639 14.3228 7.11062C14.3228 3.5573 11.4423 0.676758 7.88895 0.676758C4.33563 0.676757 1.45509 3.5573 1.45509 7.11062Z",
    stroke: "#004C97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16409 7.1111C4.16409 9.16829 5.83177 10.836 7.88896 10.836C9.94615 10.836 11.6138 9.16829 11.6138 7.1111C11.6138 5.05391 9.94615 3.38623 7.88896 3.38623C5.83178 3.38623 4.16409 5.05391 4.16409 7.1111Z",
    stroke: "#004C97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.21173 7.11084C7.21173 7.48488 7.51494 7.78809 7.88897 7.78809C8.26301 7.78809 8.56622 7.48488 8.56622 7.11084C8.56622 6.73681 8.26301 6.43359 7.88897 6.43359C7.51494 6.43359 7.21173 6.73681 7.21173 7.11084Z",
    stroke: "#004C97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8676_1527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 14.2222,
    fill: "white",
    transform: "translate(15.0001) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetedPlan);
export default __webpack_public_path__ + "static/media/TargetedPlan.f6f9d8ac82dafe06fc1131ca57ff9cc4.svg";
export { ForwardRef as ReactComponent };